import React, { useState, useEffect } from "react";
import axios from "../../services/axios";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { convertLanguageToField } from "../../utils/functions";

import Header, {
  NoHeaderScroll,
  HomeHeaderLeft,
} from "../../components/navigation/header";
import Spinner from "../../components/utils/spinner";
import SexRouletteCategoryItem from "../../components/sexRoulette/categoryItem";

export default function SexRouletteCategories() {
  const { t, i18n } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get("cenas/getAllCategorias").then((response) => {
      const { data } = response;
      let promises = [];
      let result = [];
      for (let i = 0; i < data.length; i++) {
        const category = data[i];
        promises.push(
          axios
            .get(
              `cenas/getItemsByCategory?category=${category.id_categorias_cenas}`
            )
            .then((response) => {
              const cateTitle = convertLanguageToField(i18n.language, "titulo");

              result[i] = {
                ...category,
                titulo: category[cateTitle],
                items: response.data.map((item) => {
                  const title = convertLanguageToField(i18n.language, "titulo");
                  return {
                    ...item,
                    titulo: item[title],
                  };
                }),
              };
            })
        );
      }
      Promise.all(promises).then(() => {
        setCategories(result);
      });
    });
  }, []);

  const handleClick = (item) => {
    if (
      selectedItems.find(
        ({ id_item_cenas }) => id_item_cenas === item.id_item_cenas
      )
    ) {
      setSelectedItems(
        selectedItems.filter(
          ({ id_item_cenas }) => id_item_cenas !== item.id_item_cenas
        )
      );
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const handleStart = () => {
    if (selectedItems.length < 2) {
      return;
    }

    navigate("/sex-roulette/game", {
      state: {
        categories: selectedItems,
      },
    });
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={HomeHeaderLeft} HeaderCenter={() => {}} />
      <NoHeaderScroll className="ps-5 pe-5">
        {!categories?.length ? (
          <div className="flex flex-col justify-center items-center">
            <Spinner />
          </div>
        ) : (
          <div>
            <div className="mb-6">
              <h1 className="font-semibold text-lg leading-5">
                {t("selectObjects")}
              </h1>
            </div>
            {categories.map((category) => {
              return (
                <div key={`category-${category.id_categorias_cenas}`}>
                  <h2 className="font-medium mb-4">{category.titulo}</h2>
                  <div className="grid grid-cols-4 gap-4 mb-4">
                    {category.items.map((item) => (
                      <SexRouletteCategoryItem
                        onClick={handleClick}
                        key={`category-${category.id_categorias_cenas}-item-${item.id_item_cenas}`}
                        item={item}
                        active={
                          selectedItems.find(
                            ({ id_item_cenas }) =>
                              id_item_cenas === item.id_item_cenas
                          ) !== undefined
                        }
                      />
                    ))}
                  </div>
                </div>
              );
            })}
            <div className="h-20"></div>
            <div
              className={`bg-[--bg-gradient-2] absolute bottom-0 left-0 w-full p-5 transition-all duration-500 translate-y-full ${
                selectedItems.length >= 2 ? "!translate-y-0" : ""
              }`}
            >
              <button
                type="button"
                onClick={handleStart}
                className="btn btn-brand w-full p-2 font-extrabold"
              >
                {t("start")}
              </button>
            </div>
          </div>
        )}
      </NoHeaderScroll>
    </div>
  );
}
